//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
/** Components */
import { SUB_BASIC } from './index';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
//#endregion

function SUB_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const [lanList, setLanList] = useState([]); //언어 list
  const [value, setValue] = React.useState(0);
  const [monthDate, setMonthDate] = useState(dayjs().format('MM')); // SearchReducer에 없는 필드
  const [branchVal, setBranchVal] = useState('1'); // SearchReducer에 없는 필드

  const { handleCoChange, validateSelection } = useCompanyCustDep({
    requireCompany: true,
    requireCust: true,
  });

  const printItem1 = [
    {
      name: '수급업체',
      onClick: () => {
        setPrintClick1(true);
      },
    },
    // {
    //   name: '안전보건교육 실시 확인',
    //   onClick: () => {
    //     PrintLogic1();
    //   },
    // },
  ];
  const printItem2 = [
    {
      name: '적격수급인 평가',
      onClick: () => {
        setPrintClick2(true);
      },
    },
  ];
  const printItem3 = [
    {
      name: '안전보건협의체',
      onClick: () => {
        setPrintClick3(true);
      },
    },
  ];
  const printItem4 = [
    {
      name: '작업장 순회점검',
      onClick: () => {
        setPrintClick3(true);
      },
    },
  ];
  const printItem5 = [
    {
      name: '도급사업 안전보건 협의체 회의록',
      onClick: () => {
        setPrintClick5(true);
      },
    },
  ];

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);

  const [filterClick3, setFilterClick3] = useState(false); // 3번탭 버튼 이벤트
  const [searchClick3, setSearchClick3] = useState(false);
  const [addClick3, setAddClick3] = useState(false);
  const [saveClick3, setSaveClick3] = useState(false);
  const [deleteClick3, setDeleteClick3] = useState(false);
  const [printClick3, setPrintClick3] = useState(false);
  const [listClick3, setListClick3] = useState(false);

  const [filterClick4, setFilterClick4] = useState(false); // 4번탭 버튼 이벤트
  const [searchClick4, setSearchClick4] = useState(false);
  const [addClick4, setAddClick4] = useState(false);
  const [saveClick4, setSaveClick4] = useState(false);
  const [deleteClick4, setDeleteClick4] = useState(false);
  const [printClick4, setPrintClick4] = useState(false);
  const [listClick4, setListClick4] = useState(false);

  const [filterClick5, setFilterClick5] = useState(false); // 5번탭 버튼 이벤트
  const [searchClick5, setSearchClick5] = useState(false);
  const [addClick5, setAddClick5] = useState(false);
  const [saveClick5, setSaveClick5] = useState(false);
  const [deleteClick5, setDeleteClick5] = useState(false);
  const [printClick5, setPrintClick5] = useState(false);
  const [listClick5, setListClick5] = useState(false);
  //#endregion

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    setSearchClick1(true);
  };

  // 관리감독자 이동 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    else if (newValue === 2) setSearchClick3(true);
    else if (newValue === 3) setSearchClick4(true);
    else if (newValue === 4) setSearchClick5(true);
    setValue(newValue);
  };
  //#endregion

  return (
    <div className="wrap">
      <SUB_BASIC
        navigate={navigate}
        userInfo={userInfo}
        lanList={lanList}
        setLanList={setLanList}
        value={value}
        setValue={setValue}
        monthDate={monthDate}
        setMonthDate={setMonthDate}
        branchVal={branchVal}
        setBranchVal={setBranchVal}
        searchClick1={searchClick1}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        filterClick3={filterClick3}
        setFilterClick3={setFilterClick3}
        searchClick3={searchClick3}
        setSearchClick3={setSearchClick3}
        addClick3={addClick3}
        setAddClick3={setAddClick3}
        saveClick3={saveClick3}
        setSaveClick3={setSaveClick3}
        deleteClick3={deleteClick3}
        setDeleteClick3={setDeleteClick3}
        printClick3={printClick3}
        setPrintClick3={setPrintClick3}
        listClick3={listClick3}
        setListClick3={setListClick3}
        filterClick4={filterClick4}
        setFilterClick4={setFilterClick4}
        searchClick4={searchClick4}
        setSearchClick4={setSearchClick4}
        addClick4={addClick4}
        setAddClick4={setAddClick4}
        saveClick4={saveClick4}
        setSaveClick4={setSaveClick4}
        deleteClick4={deleteClick4}
        setDeleteClick4={setDeleteClick4}
        printClick4={printClick4}
        setPrintClick4={setPrintClick4}
        listClick4={listClick4}
        setListClick4={setListClick4}
        filterClick5={filterClick5}
        setFilterClick5={setFilterClick5}
        searchClick5={searchClick5}
        setSearchClick5={setSearchClick5}
        addClick5={addClick5}
        setAddClick5={setAddClick5}
        saveClick5={saveClick5}
        setSaveClick5={setSaveClick5}
        deleteClick5={deleteClick5}
        setDeleteClick5={setDeleteClick5}
        printClick5={printClick5}
        setPrintClick5={setPrintClick5}
        listClick5={listClick5}
        setListClick5={setListClick5}
        printItem1={printItem1}
        printItem2={printItem2}
        printItem3={printItem3}
        printItem4={printItem4}
        printItem5={printItem5}
        // 함수
        handleCoChange={handleCoChange}
        validateSelection={validateSelection}
        HandleChange={HandleChange}
      />
    </div>
  );
}

export default SUB_BASICF;
